/** @type {string} */
const offcanvasComponent = 'Offcanvas';
export default offcanvasComponent;
